var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import { Progress } from "@riseart/antd-provider";
import { pagePreloaderCls } from "./Page.less";
var DEFAULT_STEP = 5;
var DEFAULT_STEP_TIMEOUT = 200;
var DEFAULT_PROGRESS_HIDE_TIMEOUT = 1e3;
var MAX_VIRTUAL_LOADED_PCT = 90;
var PreloaderPage = /* @__PURE__ */ function(_Component) {
  function PreloaderPage2(props) {
    var _this;
    _classCallCheck(this, PreloaderPage2);
    _this = _callSuper(this, PreloaderPage2, [props]);
    _this.state = _this.defaultState;
    return _this;
  }
  __name(PreloaderPage2, "PreloaderPage");
  _inherits(PreloaderPage2, _Component);
  return _createClass(PreloaderPage2, [{
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function componentDidUpdate() {
      this.startProgress();
      if (this.state.percentage === 100 && this.state.show === true) {
        this.hideComponent();
      }
    }, "componentDidUpdate")
    /**
     * getDerivedStateFromProps
     *
     * @param {Props} props
     * @param {State} state
     * @returns {?Object} updates properties in state
     */
  }, {
    key: "componentWillUnmount",
    value: (
      /**
       * componentWillUnmount
       * Clears the timer to avoid memory leak
       */
      /* @__PURE__ */ __name(function componentWillUnmount() {
        this.props.actionClearPreloaderState();
        this.resetTimer();
      }, "componentWillUnmount")
    )
    /**
     * defaultState
     */
    // eslint-disable-next-line
  }, {
    key: "defaultState",
    get: /* @__PURE__ */ __name(function get() {
      return {
        percentage: 0,
        show: false,
        resolvedSubscribers: 0
      };
    }, "get")
    /**
     * HideComponent
     *
     * @param {number} timer
     */
  }, {
    key: "hideComponent",
    value: /* @__PURE__ */ __name(function hideComponent() {
      var _this2 = this;
      var timer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_PROGRESS_HIDE_TIMEOUT;
      clearInterval(this.timeoutInterval);
      this.timer = setTimeout(function() {
        _this2.setState(_this2.defaultState);
        _this2.props.actionClearPreloaderState();
      }, timer);
    }, "hideComponent")
    /**
     * resetTimer
     */
  }, {
    key: "resetTimer",
    value: /* @__PURE__ */ __name(function resetTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.timeoutInterval) {
        clearInterval(this.timeoutInterval);
        this.timeoutInterval = null;
      }
    }, "resetTimer")
    /**
     * startProgress
     */
  }, {
    key: "startProgress",
    value: /* @__PURE__ */ __name(function startProgress() {
      var _this3 = this;
      var _this$state = this.state, show = _this$state.show, percentage = _this$state.percentage;
      if (!show || percentage > MAX_VIRTUAL_LOADED_PCT) {
        clearInterval(this.timeoutInterval);
        this.timeoutInterval = null;
        return;
      }
      if (this.timeoutInterval) {
        return;
      }
      var _this$props = this.props, _this$props$step = _this$props.step, step = _this$props$step === void 0 ? DEFAULT_STEP : _this$props$step, _this$props$stepTimeo = _this$props.stepTimeout, stepTimeout = _this$props$stepTimeo === void 0 ? DEFAULT_STEP_TIMEOUT : _this$props$stepTimeo;
      this.timeoutInterval = setInterval(function() {
        var currentTimestamp = (/* @__PURE__ */ new Date()).getTime();
        var newPercentage = _this3.props.subscribers.reduce(function(sumPercentage, subscriber) {
          if (subscriber.resolved) {
            return sumPercentage + 100;
          }
          var loadedSubscriberPct = (currentTimestamp - subscriber.timestamp) / stepTimeout * step;
          return sumPercentage + Math.min(MAX_VIRTUAL_LOADED_PCT, loadedSubscriberPct);
        }, 0);
        var loadedBarPct = newPercentage / _this3.props.subscribers.length;
        _this3.setState(function(state) {
          return {
            percentage: loadedBarPct > state.percentage ? loadedBarPct : state.percentage
          };
        });
      }, stepTimeout);
    }, "startProgress")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      return this.state.show ? /* @__PURE__ */ React.createElement(Progress, {
        className: pagePreloaderCls,
        percent: this.state.percentage,
        status: "active",
        showInfo: false,
        size: {
          height: 2
        }
      }) : null;
    }, "render")
  }], [{
    key: "getDerivedStateFromProps",
    value: /* @__PURE__ */ __name(function getDerivedStateFromProps(props, state) {
      var subscribers = props.subscribers;
      var totalSubscribers = subscribers.length;
      var resolvedSubscribers = subscribers.reduce(function(result, item) {
        return item.resolved ? result + 1 : result;
      }, 0);
      if (resolvedSubscribers === state.resolvedSubscribers) {
        return state.show !== !!totalSubscribers ? {
          show: !!totalSubscribers
        } : null;
      }
      var percentage = totalSubscribers ? resolvedSubscribers / totalSubscribers * 100 : 0;
      if (totalSubscribers && resolvedSubscribers === totalSubscribers && state.show === false) {
        return null;
      }
      return _objectSpread({
        show: !!totalSubscribers,
        resolvedSubscribers
      }, percentage > state.percentage ? {
        percentage
      } : {});
    }, "getDerivedStateFromProps")
  }]);
}(Component);
_defineProperty(PreloaderPage, "defaultProps", {
  step: DEFAULT_STEP,
  stepTimeout: DEFAULT_STEP_TIMEOUT
});
export {
  PreloaderPage
};
